export { default } from "./WarningText";
